<div class="container">
</div>

<div class="user-details-container">
  <div class="details-content">
    <div  class="side-container">
      <div class="user-image">
        <figure>
          @if (employeeDetails) {
            <img [src]="employeeDetails?.ProfileData?.User.AvatarURL" alt="profileData"
              class="profile-image">
          }
        </figure>
      </div>

      <div class="user-info">
        @if (employeeDetails) {
          <h2 class="user-name">{{ employeeDetails?.ProfileData?.User?.FirstName + ' ' + employeeDetails?.ProfileData?.User?.LastName }}</h2>
        }

        @if (employeeDetails) {
          <h4 class="user-profession">{{ employeeDetails?.ProfileData?.User.Organisation }}</h4>
        }
      </div>
    </div>
    <div class="main-content">
      <div class="back-button-container">
        <a class="back-button" routerLink="/profileData-rights">
          <svg class="arrow" alt="Arrow" xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9">
            <g id="arrow_-foward_-go_-right" data-name="arrow,-foward,-go,-right" transform="translate(-1 -8.293)">
              <path id="Path" d="M13.547,8.293,18,12.793l-4.453,4.5-.817-.826,3.057-3.09H1V12.209H15.787l-3.057-3.09Z"
                transform="translate(0 0)" class="fi-fill-brand-primary-default"/>
              </g>
            </svg>
            <span fiTranslation="BUTTON_BACK"></span>
          </a>
        </div>

        <h2 class="title" fiTranslation="USER_RIGHTS_DETAILS_GENERAL_HEADLINE"></h2>
        <span class="field-name fixed" fiTranslation="FORM_ERRORMSG_HEADLINE_MANDATORY_FIELDS"></span>

        <div class="user-form">
          <div>
            <div class="form-field name">
              <label class="input-label">
                <span class="field-name" fiTranslation="USER_RIGHTS_DETAILS_ID"></span><span
              class="field-name"></span>
              <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.Id">
            </label>
          </div>

          <div class="form-field name">
            <label class="input-label">
              <span class="field-name" fiTranslation="USER_RIGHTS_DETAILS_LOGIN"></span><span
            class="field-name"></span>
            <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.Login">
          </label>
        </div>
      </div>


      <div class="form-field">
        <label class="input-label">
          <span class="field-name" fiTranslation="FORM_HEADLINE_E-MAIL"></span><span
        class="field-name">*</span>
        <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.Email">
      </label>
    </div>

    <div>
      <div class="form-field name">
        <label class="input-label">
          <span class="field-name" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_VORNAME"></span><span
        class="field-name">*</span>
        <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.FirstName">
      </label>
    </div>

    <div class="form-field name">
      <label class="input-label">
        <span class="field-name" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_NACHNAME"></span><span
      class="field-name">*</span>
      <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.LastName">
    </label>
  </div>
</div>
<div>
  <div class="form-field name">
    <label class="input-label">
      <span class="field-name" fiTranslation="FORM_HEADLINE_LANGUAGE"></span><span
    class="field-name">*</span>
    <input maxlength="500" type="text" readonly class="input-field" [value]="languages.get(employeeDetails?.ProfileData.User.LanguageCode)">
  </label>
</div>
<div class="form-field name">
  <label class="input-label">
    <span class="field-name" fiTranslation="USER_PROFILE_EDIT_HEADLINE_TELEPHONE"></span><span
  class="field-name"></span>
  <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.Phone ?? ''">
</label>
</div>
</div>

<div>
  <div class="form-field name">
    <label class="input-label">
      <span class="field-name" fiTranslation="USER_RIGHTS_DETAILS_GENDER"></span><span
    class="field-name"></span>
    <input maxlength="500" type="text" readonly class="input-field" [value]="employeeDetails?.ProfileData.User.Gender ?? ''">
  </label>
</div>

<div class="form-field name">
  <label class="input-label">
    <span class="field-name" fiTranslation="USER_RIGHTS_DETAILS_MANDANT"></span><span
  class="field-name"></span>
  <input maxlength="500" type="text" readonly class="input-field" [value]="mandant?.Name">
</label>
</div>
</div>



<div class="separator"></div>
<h2 class="title" fiTranslation="USER_RIGHTS_DETAILS_HEADLINE"></h2>
<div>
  <div class="form-field select-form-fields name">
    <div class="select-form language-form">
      <p class="field-name"><span fiTranslation="USER_RIGHTS_DETAILS_OU"></span></p>
      <div fiCustomSelect
        (value)="updateOrgUnit($event)"
        [placeHolder]="selectedOrgUnitText"
        [data]="employeeDetails?.ActiveOuns"
        [dataValueKey]="'Id'"
        [dataNameKey]="'Description'"
        class="select-field custom-select">
        <span class="selected-value placeholder"></span>
        <img src="assets/icons/arrow-down-dark.svg" alt="arrow" class="arrow">

        <div class="options-cont">
          <ul class="options"></ul>
        </div>
      </div>
    </div>
  </div>
  <div class="form-field select-form-fields name">
    <div class="select-form language-form">
      <p class="field-name"><span fiTranslation="USER_RIGHTS_DETAILS_ADDITIONAL_OU"></span></p>
      <div fiCustomSelect
        [placeHolder]="selectedOrgUnitsText"
        (value)="updateOrgUnits($event)"
        [isMultiSelect]="true"
        [selectedData]="selectedOrgUnits"
        [data]="employeeDetails?.ActiveOuns"
        [dataValueKey]="'Id'"
        [dataNameKey]="'Description'"
        class="select-field custom-select">
        <span class="selected-value placeholder"></span>
        <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">

        <div class="options-cont">
          <ul class="options"></ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <div class="form-field select-form-fields name checkbox-box">
    <p class="field-name"><span fiTranslation="USER_RIGHTS_DETAILS_AREA"></span></p>
    @if (employeeDetails) {
      <div>
        @for (checkbox of employeeDetails?.ActiveAreas; track checkbox; let i = $index) {
          <div class="select-form status-form" (click)="checkbox.Enabled = !checkbox.Enabled">
            <div class="status-form-checkbox">
              @if (checkbox.Enabled) {
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15.275" height="13.094" viewBox="0 0 15.275 13.094">
                    <path id="Path_732" data-name="Path 732"
                      d="M313.754,334.265l-3.066-3.446-1.888,2.122,4.016,4.515a1.236,1.236,0,0,0,1.888,0l4.738-5.326,4.633-5.208-1.888-2.122Z"
                      transform="translate(-308.8 -324.8)" class="fi-fill-brand-primary-default"/>
                    </svg>
                  </div>
                }
              </div>
              <div class="checked-status-form-checkbox-text">
                <span>{{checkbox.Description}} {{checkbox.Number}}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="form-field select-form-fields name checkbox-box">
      <p class="field-name"><span fiTranslation="USER_RIGHTS_DETAILS_NOTIFICATIONS"></span></p>
      <div>
        @for (checkbox of notificationCheckboxes; track checkbox; let i = $index) {
          <div class="select-form status-form" (click)="body.ProfileData[checkbox.property] = !body.ProfileData[checkbox.property]">
            <div class="status-form-checkbox">
              @if (body.ProfileData[checkbox.property]) {
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15.275" height="13.094" viewBox="0 0 15.275 13.094">
                    <path id="Path_732" data-name="Path 732"
                      d="M313.754,334.265l-3.066-3.446-1.888,2.122,4.016,4.515a1.236,1.236,0,0,0,1.888,0l4.738-5.326,4.633-5.208-1.888-2.122Z"
                      transform="translate(-308.8 -324.8)" class="fi-fill-brand-primary-default"/>
                    </svg>
                  </div>
                }
              </div>
              <div class="checked-status-form-checkbox-text">
                <span [fiTranslation]="checkbox.snippet"></span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="form-field select-form-fields">
      <p class="field-name"><span fiTranslation="USER_RIGHTS_DETAILS_ROLES"></span></p>
      @if (employeeDetails) {
        <div >
          @for (role of employeeDetails?.ActiveRoles; track role; let i = $index) {
            <div class="role-cont" [class.last]="i === employeeDetails?.ActiveRoles.length - 1">
              <div class="left">
                <div class="role-title">
                  {{role.RoleName}}
                </div>
              </div>
              <div class="right">
                <fi-switch class="toggle-btn switch" [(ngModel)]="role.Enabled">
                </fi-switch>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="separator"></div>
    @if (employeeDetails) {
      <button type="submit" class="submit-btn" (click)="onSave()">
        <img src="assets/icons/save-blue.svg" alt="save" class="icon">
        <span class="text" fiTranslation="USER_RIGHTS_DETAILS_SAVE"></span>
      </button>
    }
  </div>
</div>
</div>
</div>

